<template>

	<section class="col-7 margin-b-100 order" v-if="order">

		<header class="header margin-b-50 padding-b-50 border-b">

			<h1>Ordre</h1>

			<p>Nedenfor kan du se den valge menu og evt. tilkøb.</p>

		</header>

		<section class="col-12 content margin-b-75 padding-b-75 border-b">

			<section class="col-12 margin-b-100">

				<h1>{{order.details.title}} ({{order.details.quantity}} stk.) <span dusk="product-price">{{stripeAmount(productPrice).amount}},-</span></h1>

				<template v-for="selection in selectionsFiltered">
					<h2>{{selection.title}}</h2>
					<ul>
                        <template v-for="option in selection.options">
                            <li>{{option.option.title}} ({{option.quantity}} stk.)</li>
                        </template>
                        <li v-if="selectionHasPremiumSelected(selection)" class="premium-total">Total <span>{{stripeAmount(selectionSelectedPremiumOptionsTotal(selection)).amount * order.details.quantity}},-</span></li>
					</ul>
				</template>

			</section>

			<section class="col-12 margin-b-100">

				<h1>Miljø- og emballageafgift <span>{{stripeAmount(packaging).amount}},-</span></h1>

			</section>

            <section class="col-12 margin-b-100" v-if="order.delivery.with_delivery">

                <h1>Levering <span>{{stripeAmount(order.delivery.delivery_fee).amount}},-</span></h1>

            </section>

			<section class="col-12">

				<h1>Pris</h1>

				<h3>Samlet pris <span dusk="total">{{stripeAmount(total).amount}},-</span></h3>

			</section>

		</section>

		<section class="col-12 flex--space">

			<router-link :to="{name:'make-productless-order.product'}">Tilbage</router-link>

			<a class="btn--primary btn--sm primary--copper" href="#" @click.prevent="goToInformations" dusk="summary-done">Gå til Oplysninger</a>

		</section>
	</section>

</template>

<script>
	import {mapGetters} from 'vuex';
	import totalCalculation from './../mixins/totalCalculation';
    export default {
        name: "order-summary",
		mixins: [totalCalculation],
		computed:{
			...mapGetters({
				order:'productless/order',
				packaging_fee:'packaging_fee',
			}),
			selectionsFiltered(){
			    return this.order.details.selections;
			},
		},
		methods:{
			goToInformations(){
                this.$store.dispatch('productless/completedSummary');
                this.$router.push({name:'make-productless-order.order.information'});
			}

		}
    }
</script>

<style scoped>

</style>
